/**
 * Signale que l'utilisateur vient d'ouvrir son planning. Sert de repère à celui
 * qui organise le travail (« vu le… ») ; rien n'est validé ni bloqué par là.
 */
import { useEffect } from 'react';
import { api } from '../../core/api.js';
import { useAuth } from '../../core/auth.js';

export function usePlanningSeen(): void {
  const { me } = useAuth();
  const active = Boolean(me && !me.support_session);
  useEffect(() => {
    if (!active) return;
    // Hors ligne ou refusé : sans conséquence, le prochain passage le signalera.
    void api('/planning/seen', { method: 'POST' }).catch(() => undefined);
  }, [active]);
}
